import styled from 'styled-components';
export const StayLoggedInButton = styled.button`
  padding: 9px;
  color: white;
`;
